/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.RoyaltyExport {
    "use strict";
    
    export class RoyaltyExportContext extends Meevo.Components.CommonClasses.CommonContextBase {
        public $rootScope: any;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            $rootScope: ng.IRootScopeService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.$rootScope = $rootScope;

            this.sectionTemplatePath = "app/plugins/royaltyExport/sectionViews/";
            this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_ROYALTYEXPORTSETTINGS_TAB_MAIN);
            
            this.initializeSections();
        }
     
        initializeSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsCommonDataService = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                appSettings: this.appSettings,
                isPrimarySection: true,
                handlesOwnCrud: false,
                baseEndpoint: '',
                sectionEndpoint: '',
                loggingService: this.loggingService,
                dataService: this.dataService,
                identityService: this.identityService,
                noun: Meevo.Model.NounEnum.RoyaltyExport,
                busyService: this.busyService,
                sectionSecurityKey: ''
            };

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_ROYALTYEXPORTSETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 0,
                        displayNameContentKey: 'SECTION_ROYALTY_EXPORT_MAIN',
                        template: 'main.html',
                        modalService: this.modalService,
                        securityChecker: this.securityChecker,
                        noun: Meevo.Model.NounEnum.RoyaltyExportMain,
                        sectionSecurityKey: this.securityKeys.MANAGEMENT_ROYALTYEXPORTSETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        context: this
                    })));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_ROYALTYEXPORTSETTINGS_TAB_EXCLUSIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ExclusionsSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 1,
                        displayNameContentKey: 'SECTION_ROYALTY_EXPORT_EXCLUSIONS',
                        template: 'exclusions.html',
                        modalService: this.modalService,
                        securityChecker: this.securityChecker,
                        baseEndpoint: this.appSettings.API_ENDPOINTS.royaltyExport,
                        sectionEndpoint: 'ExclusionsSettings',
                        noun: Meevo.Model.NounEnum.RoyaltyExportExclusions,
                        sectionSecurityKey: this.securityKeys.MANAGEMENT_ROYALTYEXPORTSETTINGS_TAB_EXCLUSIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        context: this
                    })));
            }
           
            this.activate();
        }

        initializeHeader(model: any): void { }

        scheduleRoyaltyExport(report?: any): void {
            let stateParams: any = {
                callbackState: this.appSettings.ROUTE_NAMES.royaltyExport,
                targetState: Model.MaintenanceFormVisualState.Detail,
                initialEditSection: 'SECTION_MAIN'
            };

            if (report) {
                // Edit report
                stateParams.id = report.id;
                stateParams.reportSchedule = report;
                stateParams.actionState = Model.MaintenanceFormState.Readonly;

                this.usageTrackingLog(Meevo.Model.NounEnum.RoyaltyExport, Meevo.Model.VerbEnum.EditButtonClicked, `Clicked to edit Royalty Export (${report.displayName})`);
            } else {
                // Add new Royalty Export Report
                stateParams.reportId = 224; // 224 - Core Royalty Report ID
                stateParams.actionState = Model.MaintenanceFormState.Adding;

                this.usageTrackingLog(Meevo.Model.NounEnum.RoyaltyExport, Meevo.Model.VerbEnum.ClickedToSchedule);
            }

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.reportScheduler,
                stateParams: stateParams
            });
        }

        usageTrackingLog(nounEnum: Meevo.Model.NounEnum, verbEnum: Meevo.Model.VerbEnum, description?: string): void {
            var trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, null, null, description);
            this.trackingService.saveTrackingInfo(trackingItem);
        }

    }
}
